// Redirect to custom domain in production
if (
  import.meta.env.MODE !== 'development' &&
  import.meta.env.VITE_CUSTOM_DOMAIN &&
  window.location.hostname !== import.meta.env.VITE_CUSTOM_DOMAIN
) {
  window.location.href = `https://${import.meta.env.VITE_CUSTOM_DOMAIN}`;
}

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
